import { useState } from 'react';
import useEffectOnce from './use-effect-once';
function useComputedStyle(elementRef) {
    const [style, setStyle] = useState(null);
    useEffectOnce(() => {
        if (elementRef.current) {
            const computedStyle = window.getComputedStyle(elementRef.current);
            setStyle(computedStyle);
        }
    });
    return style;
}
export default useComputedStyle;
//# sourceMappingURL=use-computed-style.js.map